import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { LocationContextService } from '../../../../client/app/location-context/location-context.service';
import { IEventLog } from '../../../../model/event-logs';
import { ILocationContext } from '../../../../model/location-context';
import { EventLogDetailDialogComponent } from '../event-log-detail-dialog/event-log-detail-dialog.component';
import { EventLogsService } from '../event-logs.service';

@Component({
    selector: 'app-event-logs',
    templateUrl: './event-logs.component.html',
    styleUrls: ['./event-logs.component.scss']
})
export class EventLogsComponent implements OnInit, OnDestroy {
    sub: Subscription;
    loading: boolean;

    displayedColumns: string[] = ['dateString', 'eventType'];
    dataSource = new MatTableDataSource<IEventLog>();
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    nodataFound = false;

    locationContext: ILocationContext;

    constructor(
        private readonly eventLogsService: EventLogsService,
        private readonly locationContextService: LocationContextService,
        public dialog: MatDialog
    ) {}

    ngOnInit() {
        this.loading = true;

        // Get location context
        this.locationContext = this.locationContextService.getLocationContext();

        // Request data
        this.eventLogsService.requestEventLogs(this.locationContext);

        // Load data
        this.sub = this.eventLogsService.getEventLogs().subscribe(eventLogs => {
            this.loading = false;

            this.dataSource = new MatTableDataSource<IEventLog>(eventLogs);
            this.nodataFound = this.dataSource.data.length === 0;

            if (this.paginator) {
                this.paginator.length = eventLogs.length;
                this.dataSource.paginator = this.paginator;
            }

            this.dataSource.sort = this.sort;
        });
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    showDetail(eventLog: IEventLog) {
        this.dialog.open(EventLogDetailDialogComponent, {
            data: eventLog
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
